/**
 * KAN-1056: the splash glide's place in its loop comes from the CLOCK, not from
 * when the page loaded. The static preloader (public/splash-phase.js — the CSP
 * allows no inline script) and the React splash both start at Date.now() % cycle,
 * so the preloader → React hand-off lines up, and so does a silent update's
 * reload: the new page's glide continues where the old page's left off instead
 * of restarting (KAN-988 only synced the hand-off within one page load).
 * Keep SPLASH_ROUTE_CYCLE_MS equal to public/splash-phase.js and the 1.6s in
 * SplashProgress.css / index.html (guard: splashRoutePhase.test.js).
 */
export const SPLASH_ROUTE_CYCLE_MS = 1600;

export function readSplashRoutePhaseMs(now = Date.now()) {
  const t = Number(now);
  return Number.isFinite(t) && t >= 0 ? t % SPLASH_ROUTE_CYCLE_MS : 0;
}

/** Negative delay = start that far into the loop. */
export function splashRoutePhaseDelay(phaseMs) {
  return `${-Math.round(phaseMs)}ms`;
}
